import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { catchError, EMPTY, take } from 'rxjs';
import { GcpLogBody, GcpLogParams } from './models';

@Injectable({ providedIn: 'root' })
export class GcpLogsApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.API.endpoint.logs;
  private readonly bearerToken = this.parseBearerToken();

  send(params: GcpLogParams, body: GcpLogBody, keepalive: boolean): void {
    const query = new URLSearchParams({
      namespace: params.namespace,
      networkId: params.networkId,
      level: params.level,
    }).toString();
    const url = `${this.baseUrl}/logs?${query}`;

    const headers = this.bearerToken
      ? new HttpHeaders().set('Authorization', `Bearer ${this.bearerToken}`)
      : new HttpHeaders();

    this.http
      .post(url, body, { headers, keepalive })
      .pipe(
        take(1),
        catchError((err) => {
          // Direct console output to avoid recursion (not LogsService)
          // eslint-disable-next-line no-console
          console.error('[GcpLogsApiService] Failed to send log to GCP', err);
          return EMPTY;
        })
      )
      .subscribe();
  }

  private parseBearerToken(): string | undefined {
    const raw = environment.integrations?.fournierWebservice?.apiKey ?? '';
    const match = /^<Bearer>(.+)$/.exec(raw);
    return match?.[1];
  }
}
